<template>
  <div class="p-card-body">
    <DataTable
      :value="itemPropertyLists"
      :paginator="true"
      :rows="8"
      class="p-datatable-responsive p-datatable-customers"
    >
      <Column header="S.N" > <template #body="slotProps">
          {{slotProps.index+1}}
         </template></Column>
      <Column header="Name" field="propertyName" filterField="propertyName" filterMatchMode="contains"/>
      <!-- <Column header="Commission Type" field="type" />
      <Column header="Quantity From" field="fromQty"/>
      <Column header="Quantity To" field="toQty"/> -->
        <Column header="Action" >
          <template #empty>No record found</template>
          <template #body="slotProps">
            <Button icon="pi pi-pencil" class="p-button-success p-button-sm" @click="editItemProperty(slotProps.data)"/>
            <Button icon="pi pi-trash" class="p-button-danger p-button-sm" @click="openDialog(slotProps.data.id)"/>
          </template>
        </Column>
    </DataTable>
    <!-- </div> -->
    <DeleteDialog v-model="dialogShow" @cancel="cancel" @deleted="deleteItemProperty"/>
      </div>
  <!-- </section> -->
</template>
<script>
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import DeleteDialog from '../../../layout/dialog'
import Button from 'primevue/button'
export default {
  name: 'ListItemProperty',
  data () {
    return {
      dialogShow: false,
      deleteReason: '',
      commisionId: null,
      show: false
    }
  },
  computed: {
    itemPropertyLists() {
      return this.$store.state.itemgroup.itemPropertyLists
    }
  },
  mounted() {
    this.itemPropertyList()
  },
  methods: {
    async itemPropertyList() {
      await this.$store.dispatch('loadItemPropertyList')
    },
    async deleteItemProperty(value) {
      if (value.trim() === '') {
        let message = {
          message: 'Delete Reason cannot be empty.',
          messageType: 'error'
        }
        this.$emit('delete-message', message)
        this.dialogShow = true
        return
      }
      let deleteRe = {
        id: this.commisionId,
        deleteReason: value
      }
      let resp = await this.$store.dispatch('deleteItemProperty', deleteRe)
      if (resp.data.status === 'SUCCESS') {
        let message = {
          message: resp.data.message,
          messageType: 'success'
        }
        this.$emit('delete-message', message)
      } else {
        let message = {
          message: resp.data.message,
          messageType: 'warn'
        }
        this.$emit('delete-message', message)
      }
      this.closeDialog()
    },
    editItemProperty(data) {
      this.$emit('edit-property', data)
    },
    cancel(data) {
      this.show = false
      this.dialogShow = false
    },
    openDialog(id) {
      this.dialogShow = true
      this.commisionId = id
    },
    closeDialog() {
      this.dialogShow = false
      this.deleteReason = ''
    }
  },
  components: {
    DataTable,
    Column,
    DeleteDialog,
    Button
  }
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// propertyList.vue?4266bac9